module.exports = __webpack_public_path__ + "static/media/home_form.04e847e3.png";